<template>


  <div class="service-center">
    <el-table ref="multipleTable" :data="tableData" tooltip-effect="dark" style="width: 100%"
              @selection-change="handleSelectionChange"
              border
    >
      <el-table-column type="selection" width="55">
      </el-table-column>
      <el-table-column label="日期选择器">
        <template slot-scope="scope">
          <el-date-picker v-model="scope.row.date" type="date" placeholder="选择日期">
          </el-date-picker>
        </template>
      </el-table-column>
      <el-table-column label="下拉框">
        <template slot-scope="scope">
          <el-select v-model="scope.row.name" placeholder="请选择">
            <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </template>
      </el-table-column>
      <el-table-column  label="输入框" show-overflow-tooltip>
        <template slot-scope="scope" >
          <el-input v-model="scope.row.address" placeholder="请输入内容" style="border: 0"></el-input>
        </template>
      </el-table-column>
      <el-table-column  label="p标签" show-overflow-tooltip>
        <template slot-scope="scope">
          <p v-text="'99999999999999999999999999'"></p>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>
<script>
export default {
  data() {
    return {
      form: {
        name: '',
        id: '',
        item: [],
        removeIdList:[]
      },
      options: [{
        value: '1',
        label: '黄金糕'
      }, {
        value: '2',
        label: '双皮奶'
      }, {
        value: '3',
        label: '蚵仔煎'
      }, {
        value: '4',
        label: '龙须面'
      }, {
        value: '5',
        label: '北京烤鸭'
      }],
      tableData: [{
        date: '2016-05-03',
        name: '1',
        address: '上海市普陀区金沙江路 1518 弄'
      }, {
        date: '2016-05-02',
        name: '2',
        address: '上海市普陀区金沙江路 1518 弄'
      }, {
        date: '2016-05-04',
        name: '3',
        address: '上海市普陀区金沙江路 1518 弄'
      }, {
        date: '2016-05-01',
        name: '4',
        address: '上海市普陀区金沙江路 1518 弄'
      }, {
        date: '2016-05-08',
        name: '',
        address: '上海市普陀区金沙江路 1518 弄'
      }, {
        date: '2016-05-06',
        name: '',
        address: '上海市普陀区金沙江路 1518 弄'
      }, {
        date: '2016-05-07',
        name: '',
        address: '上海市普陀区金沙江路 1518 弄'
      }],
      multipleSelection: []
    }
  },
  methods: {
    //加一行
    addList(){
      this.form.item.push({
        carNumber:'',
        toll:'',
      });
    },
    //删除数据
    delList(item,index){
      this.$confirm("是否确认删除？","提示",{
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.form.item.splice(index,1)
        if(item.id){
          //如果是在修改的时候删除其中一个数据，则保存Id，方便后端做删除操作
          this.form.removeIdList.put(item.id);
        }
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    handleSelectionChange(val) {
      console.log('下面打印的是选中的数据')
      console.log(val)
      this.multipleSelection = val;
    },
}
}
</script>
<style>
.el-table .el-table__cell {
  padding: 0px;
  min-width: 0;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  text-overflow: ellipsis;
  vertical-align: middle;
  position: relative;
  text-align: left;
}

.el-table .cell {
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: normal;
  word-break: break-all;
  line-height: 23px;
  padding-left: 0px;
  padding-right: 0px;
}

.el-input__inner {
  -webkit-appearance: none;
  background-color: #FFF;
  border-radius: 4px;
  border: 0px solid #DCDFE6;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  color: #606266;
  display: inline-block;
  font-size: inherit;
  height: 40px;
  line-height: 40px;
  outline: 0;
  padding: 0 15px;
  -webkit-transition: border-color .2s cubic-bezier(.645,.045,.355,1);
  transition: border-color .2s cubic-bezier(.645,.045,.355,1);
  width: 100%;
}

</style>



// WEBPACK FOOTER //
// src/components/test.vue